import React from "react";
import { MdClose } from "react-icons/md";

export default function Modal({ aberto, titulo, onFechar, children, largura = "max-w-2xl" }) {
  if (!aberto) return null;

  return (
    <div
      className="fixed inset-0 z-[1000] flex items-start justify-center overflow-y-auto bg-black/50 p-4 pt-16"
      onClick={onFechar}
    >
      <div
        className={`w-full ${largura} rounded-[20px] bg-white p-6 shadow-3xl dark:!bg-navy-800 dark:text-white`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-4 flex items-center justify-between">
          <h4 className="text-xl font-bold text-navy-700 dark:text-white">{titulo}</h4>
          <button onClick={onFechar} className="text-gray-500 hover:text-gray-700 dark:hover:text-white">
            <MdClose className="h-6 w-6" />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
